import {
  MESSAGE_SET,
  MESSAGE_REMOVE,
} from '../../actions/messages/types';

const emptyState = {
  type: null,
  message: null,
  messageId: null,
};

export default (state = emptyState, action) => {
  switch (action.type) {
    case MESSAGE_SET:
      if (action.data.message && action.data.type) {
        return Object.assign(
          {},
          action.data,
        );
      }
      return state;
    case MESSAGE_REMOVE:
      return (action.data.messageId === state.messageId) ? emptyState : state;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/reducers/messages/index.js